<div class="radio-group" [ngClass]="orientation" *ngIf="lineSize === 0" [attr.disabled]="notEnabled ? '' : null"
     [style.marginTop.px]="marginTop">
    <div class="radio" *ngFor="let so of options">
        <aa-radio [toTranslate]="toTranslate" [option]="so" name="{{ name }}"> </aa-radio>
    </div>
</div>
<div class="radio-group" *ngIf="lineSize !== 0" [attr.disabled]="notEnabled ? '' : null"
     [style.marginTop.px]="marginTop">
    <table>
        <tr *ngFor="let line of lines; index as i">
            <td *ngFor="let so of options.slice(i * lineSize, (i + 1) * lineSize)">
                <aa-radio [toTranslate]="toTranslate" [option]="so" name="{{ name }}"> </aa-radio>
            </td>
        </tr>
    </table>
</div>
